export default {
  LOAD_PROJECTS: 'LOAD_PROJECTS',
  LOAD_PROJECT: 'LOAD_PROJECT'
};
